import i18n from "../../i18n";

export const CONSISTENCY_OPTIONS = [
  { value: "constipation", label: "Const.", color: "#E57373" },
  { value: "normal", label: "Normal" },
  { value: "slightly_soft", label: "Soft", color: "#FFB74D" },
  { value: "diarrhoea", label: "Diarr.", color: "#EF5350" },
];

export const toLocalDatetimeString = (dateInput) => {
  if (!dateInput) return "";
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "";
  const tzOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - tzOffset).toISOString().slice(0, 16);
};

export const formatTimeNoSeconds = (isoTime) => {
  const date = new Date(isoTime);
  const pad = (num) => (num < 10 ? "0" + num : num);
  return `${pad(date.getHours())}.${pad(date.getMinutes())}`;
};

export const formatDurationNoSeconds = (startIso, endIso) => {
  const start = new Date(startIso).getTime();
  const end = new Date(endIso).getTime();
  if (isNaN(start) || isNaN(end)) return "";
  const totalMinutes = Math.floor((end - start) / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours > 0 ? `${hours}h ${minutes} min` : `${minutes} min`;
};

export const formatDurationWithSeconds = (startIso, endIso) => {
  const start = new Date(startIso).getTime();
  const end = new Date(endIso).getTime();
  if (isNaN(start) || isNaN(end)) return "";
  const totalSeconds = Math.floor((end - start) / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return hours > 0
    ? `${hours}h ${minutes} min ${seconds} sec`
    : `${minutes} min ${seconds} sec`;
};

export const getFeedingDurationLabel = (entry) => {
  const effectiveEnd = entry.end ? entry.end : new Date().toISOString();
  return entry.active
    ? formatDurationWithSeconds(entry.start, effectiveEnd)
    : formatDurationNoSeconds(entry.start, effectiveEnd);
};

export const groupLogByDay = (entries) =>
  entries.reduce((groups, entry) => {
    const dateStr = entry.start || entry.scheduled;
    const day = new Date(dateStr).toLocaleDateString();
    if (!groups[day]) {
      groups[day] = [];
    }
    groups[day].push(entry);
    return groups;
  }, {});

export const formatDay = (dateInput) => {
  if (dateInput === undefined) return i18n.t("log.no_registration");
  const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  const locale = i18n.language === "da" ? "da-DK" : "en-US";
  const weekday = date.toLocaleDateString(locale, { weekday: "short" }).toLowerCase();
  const day = date.getDate();
  const month = date.toLocaleDateString(locale, { month: "short" }).toLowerCase();
  const year = date.getFullYear();
  return `${weekday} d. ${day} ${month}. ${year}`;
};

export const MEDICINE_OPTIONS = [
  "D-dråber",
  "Panodil",
  "Antihistamin",
  "Astma (Orange)",
  "Astma (Blå)",
];

export const getMedicineChipSx = (medicine) => {
  if (medicine === "Astma (Orange)")
    return { backgroundColor: "#FF9800", color: "#fff" };
  if (medicine === "Astma (Blå)")
    return { backgroundColor: "#2196F3", color: "#fff" };
  return {};
};
